import { Navigate, Route, Routes } from 'react-router-dom';
import { RequireAuth, RequirePermission, useAuth } from '@/features/auth';
import { AppLayout } from '@/app/ui/AppLayout';
import { LoginPage } from '@/pages/login';
import { InvitePage } from '@/pages/invite';
import { ProfilePage } from '@/pages/profile';
import { PlaygroundPage } from '@/pages/playground';
import { ChatsPage } from '@/pages/chats';
import { ContactsPage, CrmCardPage, CrmContactPage, CrmPage, CrmSourcesPage } from '@/pages/crm';
import { KnowledgePage } from '@/pages/knowledge';
import { RemarksPage } from '@/pages/remarks';
import { UsersPage } from '@/pages/users';

function HomeRedirect() {
  const { hasPermission } = useAuth();
  if (hasPermission('can_use_playground')) return <Navigate to="/playground" replace />;
  if (hasPermission('can_view_chats')) return <Navigate to="/chats" replace />;
  if (hasPermission('can_view_crm')) return <Navigate to="/crm" replace />;
  return <Navigate to="/profile" replace />;
}

export function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/invite/:token" element={<InvitePage />} />
      <Route element={<RequireAuth />}>
        <Route element={<AppLayout />}>
          <Route index element={<HomeRedirect />} />
          <Route path="profile" element={<ProfilePage />} />
          <Route
            path="playground"
            element={
              <RequirePermission permission="can_use_playground">
                <PlaygroundPage />
              </RequirePermission>
            }
          />
          <Route
            path="playground/:dialogId"
            element={
              <RequirePermission permission="can_use_playground">
                <PlaygroundPage />
              </RequirePermission>
            }
          />
          <Route
            path="chats"
            element={
              <RequirePermission permission="can_view_chats">
                <ChatsPage />
              </RequirePermission>
            }
          />
          <Route
            path="chats/:dialogId"
            element={
              <RequirePermission permission="can_view_chats">
                <ChatsPage />
              </RequirePermission>
            }
          />
          <Route
            path="crm"
            element={
              <RequirePermission permission="can_view_crm">
                <CrmPage />
              </RequirePermission>
            }
          />
          <Route
            path="crm/sources"
            element={
              <RequirePermission permission="can_view_crm">
                <CrmSourcesPage />
              </RequirePermission>
            }
          />
          <Route
            path="crm/cards/:cardId"
            element={
              <RequirePermission permission="can_view_crm">
                <CrmCardPage />
              </RequirePermission>
            }
          />
          <Route
            path="contacts"
            element={
              <RequirePermission permission="can_view_crm">
                <ContactsPage />
              </RequirePermission>
            }
          />
          <Route
            path="contacts/:contactId"
            element={
              <RequirePermission permission="can_view_crm">
                <CrmContactPage />
              </RequirePermission>
            }
          />
          <Route
            path="crm/contacts/:contactId"
            element={
              <RequirePermission permission="can_view_crm">
                <CrmContactPage />
              </RequirePermission>
            }
          />
          <Route
            path="remarks"
            element={
              <RequirePermission permission="can_view_remarks">
                <RemarksPage />
              </RequirePermission>
            }
          />
          <Route
            path="knowledge"
            element={
              <RequirePermission permission="can_edit_knowledge_base">
                <KnowledgePage />
              </RequirePermission>
            }
          />
          <Route
            path="users"
            element={
              <RequirePermission permission="can_manage_users">
                <UsersPage />
              </RequirePermission>
            }
          />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
